import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Col, FormGroup, FormInput, FormSelect, Row } from 'shards-react'
import { setApplicantsFormData, applicantsActions } from '../../../../redux/reducers/Applicants/applicantsReducer'
import { organizationList } from '../../../../redux/reducers/organization-list-reducer'

const ApplicantsForm = () => {
  const dispatch = useDispatch()
  const form = useSelector(state => state.reports.applicants.form)
  const orgList = useSelector(state => state.reports.orgList.data)
  const auth = useSelector(state => state.auth.data)

  useEffect(() => {
    if (orgList !== undefined && orgList.length === 0) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = e => {
    const { name, value } = e.target
    const school = (name === 'org' && value !== '0') ? '0' : form.school
    dispatch(setApplicantsFormData({ ...form, school, [name]: value }))
  }

  const onSubmit = () => {
    dispatch(applicantsActions.applicantsRequestStart({ ...auth, ...form }))
  }

  return (
    <Row className={'my-3 align-items-end'}>
      <Col md={'auto'}>
        <FormGroup>
          <label htmlFor='date_from'>С</label>
          <FormInput
            id='date_from'
            name='date_from'
            type='date'
            size='sm'
            value={form.date_from}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      <Col md={'auto'}>
        <FormGroup>
          <label htmlFor='date_to'>По</label>
          <FormInput
            id='date_to'
            name='date_to'
            type='date'
            size='sm'
            value={form.date_to}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      <Col md={4}>
        <FormGroup>
          <label htmlFor='org'>Образовательная организация</label>
          <FormSelect
            id='org'
            name='org'
            size='sm'
            value={form.org}
            onChange={handleChange}
          >
            <option value='0'>Все организации</option>
            {orgList && orgList.map(item => (
              <option key={item.idOrganization} value={item.idOrganization}>
                {item.orgName}
              </option>
            ))}
          </FormSelect>
        </FormGroup>
      </Col>

      <Col md={3}>
        <FormGroup>
          <label htmlFor='fio'>ФИО</label>
          <FormInput
            id='fio'
            name='fio'
            type='text'
            size='sm'
            placeholder='Поиск по ФИО'
            value={form.fio}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      <Col md={'auto'}>
        <FormGroup>
          <Button onClick={onSubmit}>Обновить</Button>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default ApplicantsForm
